import * as React from "react";
import { Navigate } from "react-router-dom";

import { AuthContext } from "../context";

const Logout = ({ resetAuth }: { resetAuth: () => void }) => {
  const { fetch } = React.useContext(AuthContext);

  React.useEffect(() => {
    if (fetch) {
      resetAuth();
    }
  }, [fetch, resetAuth]);

  return fetch ? null : <Navigate replace to="/" />;
};

export default Logout;
